import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './app-loader.component.html',
})
export class LoaderComponent {
  size = input('w-8 h-8');
}
